import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';
import { uniq } from 'ramda';
import dayjs from 'dayjs';
import Utils from 'src/utils';
import { getWorkDays } from 'src/store/actions/workDayEventsActions';
import { ABSENCES_FLAG } from 'src/constants/workTimeService';
import { getEventsWithContract } from 'src/store/actions/tools/planner';
import { edeApi, wtsApi } from 'src/api';
import { toastrNetworkError, toastrNetworkSuccess } from 'src/helpers/toastr/toastrNetworkResponse';
import PostMultipleEventsToPlannerV2Adapter from 'src/helpers/adapters/PlannerAdapter/PostMultipleEventsToPlannerV2Adapter';
import PutMultipleEventsToPlannerV2Adapter from 'src/helpers/adapters/PlannerAdapter/PutMultipleEventsToPlannerV2Adapter';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import { isConfirmedRequestAbsenceError } from 'src/helpers/events/confirmedRequestAbsenceError';
import communicate from 'src/api/communicate';
import { getPlannerApiVersion, PlannerApiVersion } from 'src/containers/Planner/instruments/usePlannerApiVersion';
import { loadExcelExport } from './excelActions';
import { loadPdfExport } from './pdfActions';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const BREAKS_SUCCESS = 'LOAD_BREAKS_SUCCESS';
export const BREAKS_FAIL = 'LOAD_BREAKS_FAIL';
export const BREAKS_REQUEST = 'LOAD_BREAKS_REQUEST';
export const EVENTS_UPDATE = 'PLANNER_EVENTS_UPDATE';
export const EVENTS_UPDATE_MULTIPLE = 'PLANNER_EVENTS_UPDATE_MULTIPLE';
export const EVENTS_SUCCESS = 'LOAD_EVENTS_SUCCESS';
export const RELOAD_EVENTS_PART_SUCCESS = 'RELOAD_EVENTS_SUCCESS';
export const EVENTS_FAIL = 'LOAD_EVENTS_FAIL';
export const EVENTS_REQUEST = 'LOAD_EVENTS_REQUEST';
export const EVENT_SUMMARY_SUCCESS = 'LOAD_EVENT_SUMMARY_SUCCESS';
export const EVENT_SUMMARY_FAIL = 'LOAD_EVENT_SUMMARY_FAIL';
export const EVENT_SUMMARY_REQUEST = 'LOAD_EVENT_SUMMARY_REQUEST';
export const SUBMIT_EVENT_SUCCESS = 'SUBMIT_EVENT_SUCCESS';
export const SUBMIT_EVENT_FAIL = 'SUBMIT_EVENT_FAIL';
export const SUBMIT_EVENT_REQUEST = 'SUBMIT_EVENT_REQUEST';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAIL = 'DELETE_EVENT_FAIL';
export const DELETE_EVENT_REQUEST = 'DELETE_EVENT_REQUEST';
export const UPDATE_EVENT_FAIL = 'UPDATE_EVENT_FAIL';
export const UPDATE_EVENT_REQUEST = 'UPDATE_EVENT_REQUEST';
export const IMPORT_ABSENCES_FROM_AXAPTA_SUCCESS = 'IMPORT_ABSENCES_FROM_AXAPTA_SUCCESS';
export const IMPORT_ABSENCES_FROM_AXAPTA_FAIL = 'IMPORT_ABSENCES_FROM_AXAPTA_FAIL';
export const IMPORT_ABSENCES_FROM_AXAPTA_REQUEST = 'IMPORT_ABSENCES_FROM_AXAPTA_REQUEST';
export const PLANNED_BY_JOBS_REQUEST = 'PLANNED_BY_JOBS_REQUEST';
export const PLANNED_BY_JOBS_SUCCESS = 'PLANNED_BY_JOBS_SUCCESS';
export const PLANNED_BY_JOBS_FAIL = 'PLANNED_BY_JOBS_FAIL';
export const PUBLISH_EVENTS_REQUEST = 'PUBLISH_EVENTS_REQUEST';
export const PUBLISH_EVENTS_SUCCESS = 'PUBLISH_EVENTS_SUCCESS';
export const PUBLISH_EVENTS_FAIL = 'PUBLISH_EVENTS_FAIL';
export const PLANNER_LAW_CHECK_REQUEST = 'PLANNER_LAW_CHECK_REQUEST';
export const PLANNER_LAW_CHECK_SUCCESS = 'PLANNER_LAW_CHECK_SUCCESS';
export const PLANNER_LAW_CHECK_FAIL = 'PLANNER_LAW_CHECK_FAIL';
export const PLANNER_LAW_CHECK_RESET = 'PLANNER_LAW_CHECK_RESET';
export const USER_PLANNING_CONFIRMATIONS_REQUEST = 'USER_PLANNING_CONFIRMATIONS_REQUEST';
export const USER_PLANNING_CONFIRMATIONS_SUCCESS = 'USER_PLANNING_CONFIRMATIONS_SUCCESS';
export const USER_PLANNING_CONFIRMATIONS_FAIL = 'USER_PLANNING_CONFIRMATIONS_FAIL';
export const USER_PLANNING_CONFIRMATIONS_RESET = 'USER_PLANNING_CONFIRMATIONS_RESET';
const plannerLawCheckRequest = () => ({ type: PLANNER_LAW_CHECK_REQUEST });
export const plannerLawCheckSuccess = (payload) => ({ type: PLANNER_LAW_CHECK_SUCCESS, payload });
const plannerLawCheckFail = () => ({ type: PLANNER_LAW_CHECK_FAIL });
export const plannerLawCheckReset = () => ({ type: PLANNER_LAW_CHECK_RESET });
const loadEventsRequest = () => ({ type: EVENTS_REQUEST });
const loadEventsFail = (error) => ({ type: EVENTS_FAIL, error });
const loadEventsSuccess = (events, departmentIds, period, workDays, totalWorkingTime) => ({
    type: EVENTS_SUCCESS, events, departmentIds, period, workDays, totalWorkingTime
});
const reloadPartOfStoredEventsSuccess = (events) => ({ type: RELOAD_EVENTS_PART_SUCCESS, events });
const loadSummaryRequest = () => ({ type: EVENT_SUMMARY_REQUEST });
const loadSummaryFail = (error) => ({ type: EVENT_SUMMARY_FAIL, error });
const loadSummarySuccess = (summary) => ({ type: EVENT_SUMMARY_SUCCESS, summary });
const submitEventRequest = () => ({ type: SUBMIT_EVENT_REQUEST });
const submitEventFail = (error) => ({ type: SUBMIT_EVENT_FAIL, error });
const submitEventSuccess = () => ({ type: SUBMIT_EVENT_SUCCESS });
const deleteEventRequest = () => ({ type: DELETE_EVENT_REQUEST });
const deleteEventFail = (error) => ({ type: DELETE_EVENT_FAIL, error });
const deleteEventSuccess = (ids) => ({ type: DELETE_EVENT_SUCCESS, ids });
const updateEventRequest = () => ({ type: UPDATE_EVENT_REQUEST });
const updateEventFail = (error) => ({ type: UPDATE_EVENT_FAIL, error });
const updateMultipleEventsSuccess = (events) => ({ type: EVENTS_UPDATE_MULTIPLE, events });
const importAbsencesFromAxaptaRequest = () => ({ type: IMPORT_ABSENCES_FROM_AXAPTA_REQUEST });
const importAbsencesFromAxaptaFail = (error) => ({ type: IMPORT_ABSENCES_FROM_AXAPTA_FAIL, error });
const importAbsencesFromAxaptaSuccess = (data) => ({ type: IMPORT_ABSENCES_FROM_AXAPTA_SUCCESS, data });
const loadPlannedByJobsRequest = () => ({ type: PLANNED_BY_JOBS_REQUEST });
const loadPlannedByJobsSuccess = (plannedByJobs) => ({ type: PLANNED_BY_JOBS_SUCCESS, plannedByJobs });
const loadPlannedByJobsFail = (error) => ({ type: PLANNED_BY_JOBS_FAIL, error });
const publishEventsRequest = () => ({ type: PUBLISH_EVENTS_REQUEST });
const publishEventsSuccess = () => ({ type: PUBLISH_EVENTS_SUCCESS });
const publishEventsFail = () => ({ type: PUBLISH_EVENTS_FAIL });
const userPlanningConfirmationsRequest = () => ({ type: USER_PLANNING_CONFIRMATIONS_REQUEST });
const userPlanningConfirmationsSuccess = (confirmations) => ({ type: USER_PLANNING_CONFIRMATIONS_SUCCESS, confirmations });
const userPlanningConfirmationsFail = () => ({ type: USER_PLANNING_CONFIRMATIONS_FAIL });
function addAbsencesFlagsToRequest(request) {
    if (request.constructor.name === 'Array') {
        return request.map((entry) => addAbsencesFlagsToRequest(entry));
    }
    const requestCopy = Utils.objects.decapitalizeObject(request);
    if (requestCopy.flags)
        return request;
    if (requestCopy.isLeave)
        return ({ flags: ABSENCES_FLAG.NotPlanned, ...requestCopy });
    return request;
}
export const mailEvents = (params) => (_dispatch) => communicate({
    url: 'EventsExports/MailPlannedEvents',
    getParams: Utils.objects.getQueryStringFromObject(params),
    method: 'GET'
})
    .then(({ data }) => toastrSuccess(data))
    .catch((err) => toastrError(err));
export const generateWorkHours = (params) => (_dispatch) => communicate({
    url: 'CalendarEvents/GenerateFromPlanned',
    getParams: Utils.objects.getQueryStringFromObject(params),
    method: 'GET'
})
    .then(({ data }) => toastrSuccess(data))
    .catch((err) => toastrError(err));
export const loadEventsExcel = (params) => (dispatch) => {
    const request = {
        url: 'EventsExports',
        query: Utils.objects.getQueryStringFromObject({
            ...params,
            excludeLunchJobs: true,
            currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
        })
    };
    return dispatch(loadExcelExport(request));
};
export const loadPlannedByJobsExcel = (params) => (dispatch) => {
    const request = {
        url: 'Reports/ByJobsInPeriodExcel',
        query: Utils.objects.getQueryStringFromObject({
            ...params,
            currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
        })
    };
    return dispatch(loadExcelExport(request));
};
export const loadEventsPdf = (params) => (dispatch) => {
    const request = {
        url: 'EventsExports',
        query: Utils.objects.getQueryStringFromObject({
            ...params,
            excludeLunchJobs: true,
            currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
        })
    };
    return dispatch(loadPdfExport(request));
};
export const loadEventsPdfByObjects = (params) => (dispatch) => {
    const request = {
        url: 'EventsExports/Schedule',
        query: Utils.objects.getQueryStringFromObject({
            ...params,
            currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
        })
    };
    return dispatch(loadPdfExport(request));
};
export const importAbsenceFromYesterRequest = (params) => {
    return edeApi.yester.importLeavesList(params)
        .then(({ data }) => {
        toastrSuccess(data);
        return true;
    })
        .catch((err) => {
        toastrError(err);
        return false;
    });
};
export const importAbsencesFromAxapta = (params) => (dispatch) => {
    dispatch(importAbsencesFromAxaptaRequest());
    return communicate({
        url: 'Imports/Absences', method: 'get', getParams: Utils.objects.getQueryStringFromObject({ ...params, location: 1 })
    })
        .then(({ data }) => {
        toastrSuccess(data);
        dispatch(importAbsencesFromAxaptaSuccess(data.Data));
        return data.Data;
    })
        .catch((err) => {
        dispatch(importAbsencesFromAxaptaFail(err));
        toastrError(err);
        return false;
    });
};
export const plannerLawCheck = (params) => (dispatch) => {
    dispatch(plannerLawCheckRequest());
    return communicate({ url: 'Verifications', method: 'get', getParams: Utils.objects.getQueryStringFromObject(params) })
        .then((response) => {
        dispatch(plannerLawCheckSuccess(response.data.Data));
    })
        .catch((error) => {
        dispatch(plannerLawCheckFail());
        toastrError(error);
    });
};
export const getEventsRequest = (request, abortController) => communicate({
    url: 'Events',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject(request),
    abortController
});
export const loadEvents = (request, contractsEnabled) => (dispatch) => {
    dispatch(loadEventsRequest());
    return Promise.all([
        // @ts-ignore
        getEventsRequest(request),
        getWorkDays(request.period)
    ])
        .then(async ([events, workDays]) => {
        const { WorkDays = [], TotalWorkingTime = '' } = workDays.data.Data;
        const eventsData = events.data.Data ? events.data.Data : [];
        if (!eventsData.length) {
            toastr.warning(I18n.t('NoDataAvailable'), '');
        }
        const currentDepartments = request.userDepartmentIds.length
            ? request.userDepartmentIds
            : uniq(events.data.Data.map(({ User }) => `${User.DepartmentId}`));
        let eventsToSave = eventsData;
        if (contractsEnabled) {
            const djsPeriod = Utils.periods.periodStringToDayjsRange(request.period);
            eventsToSave = getEventsWithContract(eventsData, djsPeriod);
        }
        dispatch(loadEventsSuccess(eventsToSave, currentDepartments, request.period, WorkDays, TotalWorkingTime));
        return true;
    }).catch((error) => {
        toastrError(error);
        dispatch(loadEventsFail('Error downloading events'));
        return false;
    });
};
export const reloadPartOfStoredEvents = (request, abortController) => (dispatch) => {
    dispatch(loadEventsRequest());
    return getEventsRequest(request, abortController)
        .then((events) => {
        dispatch(reloadPartOfStoredEventsSuccess(events.data?.Data || []));
    }).catch((error) => {
        toastrError(error);
        dispatch(loadEventsFail('Error downloading events'));
    });
};
export const loadSummary = (request) => (dispatch) => {
    dispatch(loadSummaryRequest());
    return communicate({
        url: 'Events/JobsSummary', method: 'get', getParams: Utils.objects.getQueryStringFromObject(request)
    }).then((response) => {
        dispatch(loadSummarySuccess(response.data.Data));
    }).catch((error) => {
        dispatch(loadSummaryFail('Error downloading Summary'));
        toastrError(error);
    });
};
// Temporary solution during migration to new main report
// todo remove https://tarkvara.ektaco.ee/issues/32338
export const postMultipleEventsRequestV1 = (data, excludeWeekends = false) => {
    const expandedData = addAbsencesFlagsToRequest(data);
    return communicate({
        url: `Events/ForMultipleUsers?excludeWeekends=${excludeWeekends}`, method: 'post', data: expandedData
    });
};
export const postMultipleEventsRequest = (data, excludeWeekends = false, skipOverlapping = false) => {
    if (getPlannerApiVersion() === PlannerApiVersion.V1)
        return postMultipleEventsRequestV1(data, excludeWeekends);
    const expandedData = addAbsencesFlagsToRequest(data);
    const { jobs, absences } = PostMultipleEventsToPlannerV2Adapter.adapt(expandedData, { skipOverlapping, excludeWeekends });
    const promises = [];
    if (jobs.JobItems?.length)
        promises.push(wtsApi.v2.plannerAddJobsCreate(jobs));
    if (absences.AbsenceItems?.length)
        promises.push(wtsApi.v2.plannerAddAbsencesCreate(absences));
    return Promise.all(promises);
};
// todo remove https://tarkvara.ektaco.ee/issues/32338
export const submitEventV1 = (request, excludeWeekends) => (dispatch) => {
    dispatch(submitEventRequest());
    return postMultipleEventsRequestV1(request, excludeWeekends)
        .then((response) => {
        toastrSuccess(response);
        dispatch(submitEventSuccess());
    }).catch((error) => {
        toastrError(error);
        console.error(error);
        dispatch(submitEventFail('Error submitting event'));
    });
};
export const submitEvent = (request, excludeWeekends, skipOverlapping) => (dispatch) => {
    if (getPlannerApiVersion() === PlannerApiVersion.V1)
        return dispatch(submitEventV1(request, excludeWeekends));
    dispatch(submitEventRequest());
    return postMultipleEventsRequest(request, excludeWeekends, skipOverlapping)
        .then((response) => {
        // @ts-ignore
        toastrNetworkSuccess(response[0]);
        dispatch(submitEventSuccess());
    }).catch((error) => {
        toastrNetworkError(error);
        console.error(error);
        dispatch(submitEventFail('Error submitting event'));
    });
};
// todo remove https://tarkvara.ektaco.ee/issues/32338
export const submitEventFromCalendarV1 = (request) => (dispatch) => {
    dispatch(submitEventRequest());
    return communicate({
        url: 'Events/ForMultipleUsers?excludeWeekends=false', method: 'post', data: request
    }).then((response) => {
        toastrSuccess(response);
        dispatch(submitEventSuccess());
    }).catch((error) => {
        toastrError(error);
        dispatch(submitEventFail(error));
    });
};
export const submitEventFromCalendar = (request) => (dispatch) => {
    if (getPlannerApiVersion() === PlannerApiVersion.V1)
        return dispatch(submitEventFromCalendarV1(request));
    dispatch(submitEventRequest());
    return postMultipleEventsRequest(request)
        .then((response) => {
        // @ts-ignore
        toastrNetworkSuccess(response[0]);
        dispatch(submitEventSuccess());
    }).catch((error) => {
        toastrNetworkError(error);
        dispatch(submitEventFail(error));
    });
};
// todo remove https://tarkvara.ektaco.ee/issues/32338
export const updateMultipleEventsRequestV1 = (request, excludeWeekends = false) => communicate({
    url: `Events/ForMultipleUsers?excludeWeekends=${excludeWeekends}`, method: 'put', data: request
});
export const updateMultipleEventsRequest = (request, excludeWeekends = false, skipOverlapping = false) => {
    if (getPlannerApiVersion() === PlannerApiVersion.V1)
        return updateMultipleEventsRequestV1(request, excludeWeekends);
    const { jobs, absences } = PutMultipleEventsToPlannerV2Adapter.adapt(request, { excludeWeekends, skipOverlapping });
    const promises = [];
    if (jobs.JobItems?.length)
        promises.push(wtsApi.v2.plannerUpdateJobsUpdate(jobs));
    if (absences.AbsenceItems?.length)
        promises.push(wtsApi.v2.plannerUpdateAbsencesUpdate(absences));
    return Promise.all(promises);
};
export const deleteEventsRequest = (request, removeConfirmation = false) => communicate({
    url: 'Events',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject(removeConfirmation ? { ...request, removeConfirmation } : request)
});
export const deleteEvent = (request, removeConfirmation = false) => (dispatch) => {
    dispatch(deleteEventRequest());
    return deleteEventsRequest(request, removeConfirmation)
        .then((response) => {
        toastrSuccess(response);
        dispatch(deleteEventSuccess(request.ids));
        return true;
    }).catch((error) => {
        dispatch(deleteEventFail('Error deleting event'));
        // Absences generated from confirmed requests are not an error for the user, the deletion just
        // has to be confirmed once more — rethrown for useConfirmedAbsenceDeletion to pick up.
        if (isConfirmedRequestAbsenceError(error))
            throw error;
        toastrError(error);
        return false;
    });
};
// todo remove https://tarkvara.ektaco.ee/issues/32338
export const updateMultipleEventsV1 = (request) => (dispatch) => {
    dispatch(updateEventRequest());
    return communicate({
        url: 'Events/ForMultipleUsers', method: 'put', data: request
    }).then((response) => {
        toastrSuccess(response);
        dispatch(updateMultipleEventsSuccess(response.data.Data));
    }).catch((error) => {
        toastrError(error);
        dispatch(updateEventFail('Error updating event'));
    });
};
export const updateMultipleEvents = (request, skipOverlapping = false) => (dispatch) => {
    if (getPlannerApiVersion() === PlannerApiVersion.V1)
        return dispatch(updateMultipleEventsV1(request));
    return updateMultipleEventsRequest(request, false, skipOverlapping)
        .then((response) => {
        // @ts-ignore
        toastrNetworkSuccess(response[0]);
    }).catch((error) => {
        toastrNetworkError(error);
    });
};
export const loadPlannedByJobs = (request) => (dispatch) => {
    dispatch(loadPlannedByJobsRequest());
    return communicate({
        url: 'Events/ByJobsInPeriod',
        getParams: Utils.objects.getQueryStringFromObject(request),
        method: 'GET'
    }).then((response) => {
        dispatch(loadPlannedByJobsSuccess(response.data.Data));
    }).catch((error) => {
        dispatch(loadPlannedByJobsFail('Error downloading Summary'));
        toastrError(error);
    });
};
export const publishEvents = (request) => (dispatch) => {
    dispatch(publishEventsRequest());
    return communicate({
        url: 'Events/SetPublish', method: 'put', data: request
    }).then((response) => {
        // @ts-ignore
        dispatch(publishEventsSuccess(response.data.Data));
    }).catch((error) => {
        dispatch(publishEventsFail());
        toastrError(error);
    });
};
export const approveScheduleForPeriod = (data) => (_dispatch) => communicate({
    url: 'UserPlanningConfirmations/Multiple', method: 'post', data
}).then((response) => {
    toastrSuccess(response);
    return Promise.resolve(response.data.Data);
}).catch((error) => {
    toastrError(error);
    return Promise.reject();
});
export const loadUserPlanningConfirmations = (params = {}, withoutStore = false) => (dispatch) => {
    if (!withoutStore) {
        dispatch(userPlanningConfirmationsRequest());
    }
    return communicate({
        url: 'UserPlanningConfirmations', method: 'get', getParams: Utils.objects.getQueryStringFromObject(params)
    })
        .then((response) => {
        const responseData = response.data.Data;
        if (!withoutStore) {
            dispatch(userPlanningConfirmationsSuccess(responseData));
        }
        return Promise.resolve(responseData);
    })
        .catch((error) => {
        if (!withoutStore) {
            dispatch(userPlanningConfirmationsFail());
        }
        toastrError(error);
        return Promise.reject();
    });
};
export const generateCalendarEvents = async (payload) => {
    try {
        return await wtsApi.v2.plannerGenerateCalendarEventsCreate(payload);
    }
    catch (error) {
        return toastrNetworkError(error);
    }
};
